angular.module('iw.frontyard.string', [

]);